export const USE_MOCKS = import.meta.env.VITE_USE_MOCKS === 'true';

export const IS_DEV = import.meta.env.VITE_ENV_SHORTNAME === 'dev';
export const IS_STG = import.meta.env.VITE_ENV_SHORTNAME === 'stg';

export const BUCKET_URL_BASE_DEV = 'https://static.techbetterfly.com/brokers-portal';
export const BUCKET_URL_BASE_PROD = 'https://static.gobetterfly.com/brokers-portal';

export const BUCKET_URL_BASE = IS_DEV ? BUCKET_URL_BASE_DEV : BUCKET_URL_BASE_PROD;

export const IS_NOT_LOCAL = import.meta.env.VITE_ENV_SHORTNAME !== 'local';

export const BROKERS_PORTAL_URL = import.meta.env.VITE_FRONT_URL ?? '';
export const WALLET_PORTAL_URL = import.meta.env.VITE_WALLET_URL ?? '';

export const AMPLIFY_COOKIES_KEY_START = 'CognitoIdentityServiceProvider';
export const AMPLIFY_COOKIES_KEY_END_ACCESS_TOKEN = 'accessToken';

export const INTERCOM_APP_ID = import.meta.env.VITE_INTERCOM_APP_ID ?? '';
